import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    // Default to same-origin so the production bundle doesn't try to reach
    // localhost:5000 (which is correctly blocked by our CSP). REACT_APP_SOCKET_URL
    // can override for dev (e.g. when running CRA on :3000 while server is :5000).
    const sameOrigin = typeof window !== 'undefined' ? window.location.origin : '';
    const socketUrl = process.env.REACT_APP_SOCKET_URL || sameOrigin || undefined;

    const newSocket = io(socketUrl, {
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      // Path defaults to /socket.io/ — same on prod nginx + dev CRA proxy.
    });

    newSocket.on('connect', () => {
      setIsConnected(true);
      console.log('Socket connected:', newSocket.id);
    });

    newSocket.on('disconnect', () => {
      setIsConnected(false);
      console.log('Socket disconnected');
    });

    newSocket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
    });

    setSocket(newSocket);

    return () => {
      newSocket.close();
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket, isConnected }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => {
  // Returning a no-op shape rather than throwing keeps pages resilient when
  // they're rendered outside the provider (e.g. in unit tests, or if the
  // provider tree is restructured later).
  return useContext(SocketContext) || { socket: null, isConnected: false };
};

export default SocketContext;
